import React, { useContext, useEffect, useState } from "react";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {Tabs, Tab,Stack,TextField, Button, Table, TableBody, TableCell, TableContainer, TableHead,TableRow, LinearProgress } from "@mui/material";

import config from '../../hoa-config';
import datastore from '../../store/hoa-datastore';
import { GlobalContext } from '../../context/hoa-global-context';

import SubHeaderComponent from '../sub-header/hoa-sub-header';
import DeleteContainerModal from '../delete-modal/hoa-delete-modal';
import PropertyViewContainer from './view/hoa-property-view-container';
import dashboardServices from "../../services/hoa-dashboard-api-service";
import BillableItemsModal from '../billableItems-modal/billable-items-modal';
import PropertyBasicDetailsForm from './property-forms/hoa-property-basic-details';
import PropertyViolationDetails from './property-forms/hoa-property-violation-details';

import { commaSeparatedString } from "../../utility/comma-separated-string";
import { getStateNameAbbreviation, getFileExtension, getFileNameWithoutExtension, isViolationExtension } from '../../utility/helper';
import { saveNewLogsInDatastore } from "../../utility/change-log";
import { getCreatedOrUpdatedHoaDues, getCreatedOrUpdatedViolations, isPropertyOverviewUpdate, isPropertyViolationBasicInfoUpdate, getUpdatedViolationListForChangeLog, getResolvedViolationList } from "../../utility/compare-item";
import TryagainModal from "../Tryagain-modal/TryagainModal";
import CheckCircle from '@mui/icons-material/CheckCircle';
import LoadingComponent from "../loading-component/loading-component";
import hoaDatastore from "../../store/hoa-datastore";
import propertyTaskService from "../../services/hoa-property-task-service";
import { useSelectedTaskStoreStore } from "../../store/useTaskStore";
import EditCancelConfirmationModal from "../../shared-components/edit-cancel-confirmation";

interface CrudCompProps {
	view: string;
	setView: any;
	setSuccess: any;
}
const PropertyCrudComponent = (props: CrudCompProps) => {
	const { view, setView, setSuccess } = props;
	const { selectedValues, updatePropertyData, property, updateSelectedValues, updateView, hoa, updateHoaData, activeTab, updateActiveTab, changeActiveMenu, activeMenu } = useContext<any>(GlobalContext)

	const [isDisabled, setIsDisabled] = useState(true);
	const [loading, setLoading] = useState(false);
	const [propertyData, setPropertyData]: any = useState({hoaPropertyDetails:{},info:{}})
	const [error, setError] = useState({});
	const [violationError, setViolationError]:any =useState({});
	const [isSelectionFromAdd, setSelectionFromAdd] = useState(true)
	const [preHoaId,setPrevHoaId] = useState('');
	const [violationList, setViolationLists] = useState([]);
	const [prevViolationList, setPrevViolationLists] = useState([]);
	const [parentViolationList, setParentViolationList] = useState([]);
	const [isViolationLoading, setViolationLoading] = useState(false);
	const [isDeleteModal, setIsDeleteModal] = useState(false)
	const [skipPrevStatus, setSkipStatus] = useState('add')
	const [selectedBillItem, setSelectedBillItem] = useState(null);
	const [linkedEntryId, setLinkedEntryId] = useState(null);
    const [evidenceLink, setEvidenceLink] = useState(null);
    const [isBillableItemsModal, setIsBillableItemsModal] = useState(false);
	const [hoaDueList, setHoaDueLists] = useState([]);
	const [prevHoaDueList, setPrevHoaDueList] = useState([]);
	const [isHoaDueLoading, setHoaDueLoading] = useState(false);
	const [files, setFiles] = useState({
		propertyNoticeFiles: [],
		hearingNoticeFiles: []
	})
	const [sourceId, setSourceId] = useState('');
	const [isVerified, setIsVerified] = useState(null);
	const [sourceDocumentType, setSourceDocumentType] = useState('');
    const [showApiErrorModal,setShowApiErrorModal] = useState(false);
	const previousSelectedValues = JSON.parse(JSON.stringify(selectedValues));
	const [IsViolationListEmpty, setIsViolationListEmpty]=useState(false);
	const [IsHoaDueListEmpty, setIsHoaDueListEmpty]=useState(false)
	const [reorderedViolations, setReorderedViolations] = useState([]);
	const [isCancelClicked, setIsCancelClicked] = useState(false);
	const [documentId, setDocumentId] = useState("")
	const [isDocumentIdVerified, setIsDocumentIdVerified] = useState(false)
	const { findDataMatchWithSelectedValueIndex, findDataMatchWithSelectedValue } = useSelectedTaskStoreStore()

	useEffect(() => {
		if (Array.isArray(violationList) && violationList.length > 0) {
			let parentViolations:any = [];
			let childViolationIds:any = [];

			violationList.forEach((item:any) => {
				if (Array.isArray(item.childViolationIdsList)) {
					item.childViolationIdsList.forEach((id:string) => {
						if (!childViolationIds.includes(id)) {
							childViolationIds.push(id);
						}
					})
				}
			});

			parentViolations = JSON.parse(JSON.stringify(violationList)).filter((item:any, index: number) => {
				if(!item.isDeleted && !childViolationIds.includes(item.objectId)){
					if (Array.isArray(violationList[index]?.violationNoticeFiles)) {
						violationList[index].violationNoticeFiles.map((file: any, index: number) => {
							if(file?.name){
								file = new File([file], file.name, { type: file.type });
								item.violationNoticeFiles[index] = file;
							}
						});
					}

					return item;
				}
			});

			setParentViolationList(parentViolations);
		}
	}, [violationList]);

	const onCancelYesClick = () => {
		// on cancel click function
		// changeActiveMenu(activeMenu,false, "", -1);
		if (Object.keys(selectedValues).length > 0) {
			setView("view");
		}else {
			setView("list");
		}
		setIsCancelClicked(false);
		setIsDisabled(true)
		if(preHoaId && preHoaId !== '') {
			setPropertyData({...propertyData, hoaId: preHoaId})
		}
	};

	const onCancelClick = () => {
		setIsCancelClicked(!isCancelClicked)
	}

	const onUpdateClick = () => {
		if(activeMenu === 'propertiespendingtask') {
			hoaDatastore.setStartTime();
		}
		setView("update");
	};

	const createLogs = async (status:string,objectId:string,prevState?:any,updatedState?:any, type?: string, extensions?: any, billableItem?: string, propertyId?: string) => {
		// delete parseObjects
		let prev = {...prevState}
		delete prev._parseObject
		let update = {...updatedState}
		delete update._parseObject

		// set default type
		if(!type) {
			type = 'Property'
		}

		// set primaryEvent
		var events:any = [];
		var primaryEvent = "";

		if(type == 'Property') {
			primaryEvent = config.changeLongActionsProperty[status];
		}
		else if(type == 'Hoa') {
			primaryEvent = config.changeLongActionsHoa[status];
			if(status == 'propertyAssigned' && propertyId) {
				primaryEvent = `${primaryEvent} (${propertyId})`
			}
		}

		// manage extensions
        if(Array.isArray(extensions) && extensions.length > 0) {
            extensions.map(extension => {
				if(extension == 'Update HOA information' || isViolationExtension(extension)) {
					events.push(`${extension}`);
				}
				else {
					events.push(`${primaryEvent} ${extension}`);
				}
            });
        }
        else {
            events.push(primaryEvent);
        }

		if(events.length > 0) {
			const logMessage = {
				events:events,
				billItem: billableItem ? billableItem : selectedBillItem,
				linkedEntryId: linkedEntryId,
				evidenceLink: evidenceLink,
				user: datastore.ownerInformation.name,
				prevState:prev,
				updatedState:update,
				type:type,
				tagTypeId:objectId,
				sourceId: sourceId,
				sourceDocumentType: sourceDocumentType,
				documents: isVerified?.attachmentDetails ? Array.isArray(isVerified?.attachmentDetails) ? isVerified?.attachmentDetails : [isVerified?.attachmentDetails?.name] : [],
			}

			const result = await dashboardServices.createLogs(logMessage);
			saveNewLogsInDatastore(result.data, datastore);
		}
    }

	const updateLocalHoaInfo = (id:string, numberOfProperties:number) => {
		const index = hoa.data.findIndex((hoa_v:any) => hoa_v.objectId === id)
		if(index >= 0){
			let tmpHoaData = hoa.data;
			tmpHoaData[index].numberOfProperties = numberOfProperties;
			updateHoaData({
				...hoa,
				data:tmpHoaData
			})
		}
	}

	const getDeletedViolationList = () => {
		const deletedViolations = violationList.filter((violation:any) => {
			return violation.objectId && violation.isDeleted;
		});

		return deletedViolations;
	}

	const addPropertyDataToFilesName = (violationOrDueList:any) => {
		if (Array.isArray(violationOrDueList) && violationOrDueList.length > 0) {
			for (const violationOrDue of violationOrDueList) {
				if (Array.isArray(violationOrDue?.renamedFiles) && violationOrDue.renamedFiles.length > 0) {
					const newRenamedFilesWithPropertyInfo:any = [];
					for (const file of violationOrDue.renamedFiles) {
						const currentFileName = file?.name;
						if(currentFileName) {
							const currentFileNameWithoutExtension = getFileNameWithoutExtension(currentFileName);
							const currentFileExtension = getFileExtension(currentFileName);
							const currentFileNameParts = currentFileNameWithoutExtension.split('-');
							const dollarAmount = currentFileNameParts.shift();

							if (file?.name && dollarAmount && propertyData?.hoaPropertyDetails?.externalId && propertyData?.fullAddress && propertyData?.info?.state) {
								newRenamedFilesWithPropertyInfo.push(new File(
									[file],
									`${dollarAmount}-${propertyData.hoaPropertyDetails.externalId}-${propertyData.fullAddress}-${getStateNameAbbreviation(propertyData.info.state)}${currentFileNameParts.length > 0 ? '-' : ''}${currentFileNameParts.join('-')}.${currentFileExtension}`,
									{
										type: file.type
									}
								));
							}
						}
					}

					violationOrDue.renamedFiles = newRenamedFilesWithPropertyInfo;
				}
			}
		}

		return violationOrDueList;
	}

	const addOrUpdateViolation = async () => {
		setViolationLoading(true);
		let extensions:any = [];
		let violations: any = [];
		let res:any;
		// add or update violations
		let returnUpdatedViolationList: any = [];
		let createdOrUpdatedViolationList = getCreatedOrUpdatedViolations(prevViolationList, violationList, true);
		let updatedViolationList = getUpdatedViolationListForChangeLog(prevViolationList, violationList);
		let resolvedViolationList = getResolvedViolationList(prevViolationList, violationList);

		if(Array.isArray(createdOrUpdatedViolationList) && createdOrUpdatedViolationList.length > 0) {
			createdOrUpdatedViolationList = addPropertyDataToFilesName(createdOrUpdatedViolationList);
			res = await dashboardServices.saveOrUpdateMultipleViolation(createdOrUpdatedViolationList, selectedValues.objectId, propertyData.organizationId);

			if(Array.isArray(res.data)) {
				violationList.forEach((list) => {
					const matchingItem = res.data.find((item: any) => item.objectId === list.objectId);
				
					if (!matchingItem && list.objectId) {
						violations.push(list);
						
					} else if(matchingItem) {
						violations.push(matchingItem);
					}
				});

				res.data.forEach((item:any) => {
				const matchingItem = violationList.find((list) => list.objectId === item.objectId);
			
				if (!matchingItem) {
					violations.push(item);
				}
				});
			}
			returnUpdatedViolationList = res.data;
		}

		// delete violations
		let deletedViolationList = getDeletedViolationList();
		if(deletedViolationList.length > 0) {
			const violationIds = deletedViolationList.map((violation:any) => {
				return violation.objectId;
			});
			await dashboardServices.removeMultiplePropertyViolation(violationIds);
		}

		// set current updated violations and create logs
		if(createdOrUpdatedViolationList.length > 0 || deletedViolationList.length > 0) {
			const violationListCopy = JSON.parse(JSON.stringify(violationList));
			const filteredViolationListCopy = violationListCopy.filter((violation:any) => {
				return violation.isDeleted === false;
			});
			
			setViolationLists(JSON.parse(JSON.stringify(filteredViolationListCopy)));
			setPrevViolationLists(JSON.parse(JSON.stringify(filteredViolationListCopy)));
		}

		// create property violation logs
		createdOrUpdatedViolationList.forEach((item:any, index:number) => {
			if (!item.objectId) {
				if (Array.isArray(item.childViolationIdsList) && item.childViolationIdsList.length > 0) {
					extensions.push(`New Stage of a Violation is Added (${selectedValues.objectId}-${res.data[index].objectId})`);
				}
				else {
					extensions.push(`New Violation is Added (${selectedValues.objectId}-${res.data[index].objectId})`);
				}
			}
		});

		for (const item of updatedViolationList) {
			extensions.push(`Update Violation Information (${selectedValues.objectId}-${item.objectId})`)
		}

		for (const item of resolvedViolationList) {
			extensions.push(`Violation is Resolved (${selectedValues.objectId}-${item.objectId})`)
		}

		for (const item of deletedViolationList) {
			if (item.isParentViolation) {
				extensions.push(`Violation is Deleted (${selectedValues.objectId}-${item.objectId})`);
			}
			else {
				extensions.push(`Stage of a Violation is Deleted (${selectedValues.objectId}-${item.objectId})`);
			}
		}

		setReorderedViolations([]);
		setViolationLoading(false);
		return {extensions, violations};
	}

	// Hoa due create update delete and changelog
	const getDeletedHoaDuesList = () => {
		const deletedHoaDues = hoaDueList.filter((hoaDue:any) => {
			return hoaDue.objectId && hoaDue.isDeleted;
		});

		return deletedHoaDues;
	}

	const addOrUpdateHoaDues = async () => {
		setHoaDueLoading(true);
		let extensions:any = [];
		let hoaDues: any = [];
		// add or update hoa dues
		let returnUpdatedHoaDuesList: any = [];
		let updatedHoaDuesList = getCreatedOrUpdatedHoaDues(prevHoaDueList, hoaDueList, true);
		if(Array.isArray(updatedHoaDuesList) && updatedHoaDuesList.length > 0) {
			updatedHoaDuesList = addPropertyDataToFilesName(updatedHoaDuesList);
			let res = await dashboardServices.saveOrUpdateMultipleHoaDues(updatedHoaDuesList, selectedValues.objectId);
			
			if(Array.isArray(res.data)) {
				hoaDueList.forEach((list) => {
					const matchingItem = res.data.find((item: any) => item.objectId === list.objectId);
				
					if (!matchingItem && list.objectId) {
						hoaDues.push(list);
					} else if(matchingItem) {
						hoaDues.push(matchingItem);
					}
				});

				res.data.forEach((item) => {
				const matchingItem = hoaDueList.find((list) => list.objectId === item.objectId);
			
				if (!matchingItem) {
					hoaDues.push(item);
				}
				});
			}
			returnUpdatedHoaDuesList = res.data;
		}

		// delete hoa dues
		let deletedHoaDuesList = getDeletedHoaDuesList();
		if(deletedHoaDuesList.length > 0) {
			const hoaDueIds = deletedHoaDuesList.map((hoaDue:any) => {
				return hoaDue.objectId;
			});
			await dashboardServices.removeMultipleHoaDues(hoaDueIds);
		}

		// set current updated hoa dues and create logs
		if(updatedHoaDuesList.length > 0 || deletedHoaDuesList.length > 0) {
			const hoaDueListCopy = JSON.parse(JSON.stringify(hoaDueList));
			const filteredHoaDueListCopy = hoaDueListCopy.filter((hoaDue:any) => {
				return hoaDue.isDeleted === false;
			});
			let totalHoaDueList = [...returnUpdatedHoaDuesList, ...deletedHoaDuesList];
			setHoaDueLists(JSON.parse(JSON.stringify(filteredHoaDueListCopy)));
			setPrevHoaDueList(JSON.parse(JSON.stringify(filteredHoaDueListCopy)));

			totalHoaDueList.map(hoaDue => {
				extensions.push(`Hoa Dues Information (${selectedValues.objectId}-${hoaDue.objectId})`);
			})
		}

		setHoaDueLoading(false);

		return {extensions, hoaDues};
	}

	const onErrorCheck = () => {
		const overviewError = onOverviewErrorCheck();
		return overviewError;
	}

	const getViolationFees = () => {
		let totalViolationFee = 0;
		parentViolationList.length>0 && parentViolationList.map((violation: any) => {
			if(violation.isDeleted === false && violation.noticeStatus === 'active'){
				totalViolationFee += Number(violation.violationFee)
			}
		})
		return totalViolationFee.toFixed(2);
	}

	const getTotalActiveViolation = () => {
		let totalViolationCount = 0;
		parentViolationList.length>0 && parentViolationList.map((violation: any) => {
			if(violation.isDeleted === false && violation.noticeStatus === 'active'){
				totalViolationCount++
			}
		})
		return totalViolationCount;
	}

	const getHoaDuesFees = () => {
		let totalFee = 0;
		hoaDueList.length>0 && hoaDueList.map((hoaDue: any) => {
			if(hoaDue.isDeleted === false && hoaDue.noticeStatus === 'active'){
				totalFee += Number(hoaDue.invoiceAmount)
			}
		})
		return totalFee.toFixed(2);
	}

	const getTotalActiveHoaDues = () => {
		let totalCount = 0;
		hoaDueList.length>0 && hoaDueList.map((hoaDue: any) => {
			if(hoaDue.isDeleted === false && hoaDue.noticeStatus === 'active'){
				totalCount++
			}
		})
		return totalCount;
	}

	const isMailVerifiedWithPropertyCheck = async () => {
			if (activeMenu !== "propertiespendingtask") return;

			const propertyValue = findDataMatchWithSelectedValue(property.data, hoaDatastore);
			if (
				view === "update" &&
				activeMenu === "propertiespendingtask" &&
				selectedBillItem === "Update from mail" &&
				isVerified &&
				propertyValue?.taskSourceType === 'mail'&&
				sourceId === propertyValue?.mailDetails?.id
			) {
				hoaDatastore.endStartTime();
				await propertyTaskService.updateMailVerifiedStatus({
					propertyTaskId: propertyValue.mailDetails.parsePropertyTaskId,
					verificationTime: hoaDatastore.getTimeOfVerified(),
				});

				const pendingIndex = findDataMatchWithSelectedValueIndex(property.data, hoaDatastore);
				updatePropertyData({
					...property,
					data: property.data.filter((value:any, index:number) => index !== pendingIndex),
				});
				changeActiveMenu(activeMenu, false, "", -1);
				updateView("remove-from-list");
				return;
			}
			else if(
				view === "update" &&
				activeMenu === "propertiespendingtask" &&
				selectedBillItem === "Update from email" &&
				isVerified &&
				propertyValue?.taskSourceType === 'email'&&
				sourceId === propertyValue?.emailDetails?.id
			) {
				hoaDatastore.endStartTime();
				await propertyTaskService.updateMailVerifiedStatus({
					propertyTaskId: propertyValue.emailDetails.parsePropertyTaskId,
					verificationTime: hoaDatastore.getTimeOfVerified(),
				});

				const pendingIndex = findDataMatchWithSelectedValueIndex(property.data, hoaDatastore);
				updatePropertyData({
					...property,
					data: property.data.filter((value:any, index:number) => index !== pendingIndex),
				});
				changeActiveMenu(activeMenu, false, "", -1);
				updateView("remove-from-list");
				return;
			}
	}
	
	const onSaveClick = async () => {
		if (!onErrorCheck()) {
		try{   
			setLoading(true);
			setShowApiErrorModal(false)
			const {extensions: violationExtensions, violations} = await addOrUpdateViolation();
			const {extensions: duesExtensions, hoaDues} = await addOrUpdateHoaDues();

			if (view === 'add') {
				propertyData.name = commaSeparatedString(propertyData.info.street, propertyData.info.city, propertyData.info.state);
				const result = await dashboardServices.createNewProperty(propertyData, datastore.ownerInformation.id, files);

				if(result.data.propertiesNumberOfHOA){
					updateLocalHoaInfo(result.data.propertiesNumberOfHOA.id,result.data.propertiesNumberOfHOA.number);
				}

				const tmpData: any = [result.data, ...property.data];
				updatePropertyData({
					...property,
					data: tmpData,
				});
				await createLogs(props.view, result.data.objectId,{},result.data)

				if(result.data.hoaId && result.data.hoaId != preHoaId) {
					let billableItem = "";
					if(result.data?.propertiesNumberOfHOA?.propertyNumberByOrg == 1) {
						billableItem = "First property addition";
					}
					else if(result.data?.propertiesNumberOfHOA?.propertyNumberByOrg > 1) {
						billableItem = "Subsequent Property addition";
					}
					await createLogs('propertyAssigned', result.data.hoaId, {}, result.data, 'Hoa', [], billableItem, result.data.objectId);
					await createLogs(props.view,result.data.objectId,{},result.data, '', ['Update HOA information']);
				}

				if (result.status === 200) {
					props.setSuccess(true);
				}
				setFiles({
					propertyNoticeFiles:[],
					hearingNoticeFiles: []
				})
				props.setView("list");
			} else if( view === 'update') {
				let data = property.data;
				let index = 0;
				data.find((value: any, index1: number) => {
					if(value.objectId === selectedValues.objectId){
						index = index1;
					}
				});
				propertyData.name = commaSeparatedString(propertyData.info.street, propertyData.info.city, propertyData.info.state);
				if(propertyData.hoaId && propertyData.hoaId != preHoaId) {
					propertyData.hoaAssignedDate = new Date().toUTCString();
				}

				const totalViolationCount = getTotalActiveViolation();
				if((totalViolationCount && totalViolationCount > 0) || (prevViolationList.length != totalViolationCount)) {
					propertyData.hoaPropertyDetails.violationFeeOutstanding = getViolationFees();
					propertyData.hoaPropertyDetails.totalViolation = totalViolationCount;
				}
				const totalHoaDue = getTotalActiveHoaDues();
				if((totalHoaDue && totalHoaDue > 0) || (prevHoaDueList.length != totalHoaDue)) {
					propertyData.hoaPropertyDetails.invoicesOutstanding = getHoaDuesFees();
					propertyData.hoaPropertyDetails.totalInvoices = totalHoaDue;
				}
				const result:any = await dashboardServices.updateProperty(propertyData,preHoaId, files, previousSelectedValues?.organizationId)

				if(result.data.propertiesNumberOfHOA){
					updateLocalHoaInfo(result.data.propertiesNumberOfHOA.id,result.data.propertiesNumberOfHOA.number);
					if(result.data.propertiesNumberOfHOA?.preid){
						updateLocalHoaInfo(result.data.propertiesNumberOfHOA.preid,result.data.propertiesNumberOfHOA.prenumber);
					}
				}

				if(activeMenu === 'propertiespendingtask') {
					const pendingIndex = findDataMatchWithSelectedValueIndex(data, hoaDatastore)
					if (data[pendingIndex]?.taskSourceType === "mail") {
						data[pendingIndex] = {
							...result.data,
							user: data[pendingIndex].user,
							mailDetails: data[pendingIndex].mailDetails,
							taskSourceType: data[pendingIndex]?.taskSourceType,
						};
					} else if(data[pendingIndex]?.taskSourceType === "email") {
						data[pendingIndex] = {
							...result.data,
							user: data[pendingIndex].user,
							emailDetails: data[pendingIndex].emailDetails,
							taskSourceType: data[pendingIndex]?.taskSourceType,
						};
					}
				} else {
					data[index] = result.data;
				}
				if (result.status === 200) {
					updatePropertyData({
						...property,
						data: data,
					});
					
					let extensions = [];
					if(!isPropertyOverviewUpdate(selectedValues, propertyData) || files.propertyNoticeFiles.length > 0){
						extensions.push('Overview Information');
					}
					if( selectedValues.hoaPropertyDetails?.hearingNoticeFiles != result.data?.hoaPropertyDetails?.hearingNoticeFiles ||  selectedValues.hoaPropertyDetails?.hearingStatementNeeded != result.data?.hoaPropertyDetails?.hearingStatementNeeded || selectedValues.hoaPropertyDetails?.hearingAttorneyNeeded != result.data?.hoaPropertyDetails?.hearingAttorneyNeeded || selectedValues.hoaPropertyDetails?.hearingPlace != result.data?.hoaPropertyDetails?.hearingPlace || selectedValues.hoaPropertyDetails?.hearingDate != result.data?.hoaPropertyDetails?.hearingDate || selectedValues.hoaPropertyDetails?.penaltyFeePending != result.data?.hoaPropertyDetails?.penaltyFeePending || selectedValues.hoaPropertyDetails?.penalty != result.data?.hoaPropertyDetails?.penalty || selectedValues.hoaPropertyDetails?.penaltyAdditionalInfo != result.data?.hoaPropertyDetails?.penaltyAdditionalInfo || selectedValues.hoaPropertyDetails?.violationFeeOutstanding != result.data?.hoaPropertyDetails?.violationFeeOutstanding || selectedValues.hoaPropertyDetails?.totalViolation != result.data?.hoaPropertyDetails?.totalViolation || selectedValues.hoaPropertyDetails?.avgViolation != result.data?.hoaPropertyDetails?.avgViolation || selectedValues.hoaPropertyDetails?.numberOfViolation != result.data?.hoaPropertyDetails?.numberOfViolation || selectedValues.hoaPropertyDetails?.assesmentFee != result.data?.hoaPropertyDetails?.assesmentFee || selectedValues.hoaPropertyDetails?.assesmentFeeFrequency != result.data?.hoaPropertyDetails?.assesmentFeeFrequency || selectedValues.hoaPropertyDetails?.assesmentStatus != result.data?.hoaPropertyDetails?.assesmentStatus){
						extensions.push('Basic Violation');
					}
					if(result.data.hoaId && result.data.hoaId != preHoaId) {
						extensions.push('Update HOA information');
					}
					if((Array.isArray(extensions) && extensions.length>0)
						|| (Array.isArray(violationExtensions) && violationExtensions.length > 0)
							|| (Array.isArray(duesExtensions) && duesExtensions.length > 0)) {

						const prevState = previousSelectedValues;
						const currentState = JSON.parse(JSON.stringify(result.data));

						if(Array.isArray(violationExtensions) && violationExtensions.length > 0) {
							extensions = extensions.concat(violationExtensions);

							let prevViolationListCopy = JSON.parse(JSON.stringify(prevViolationList));
							let violationListCopy = JSON.parse(JSON.stringify(violations));

							for (let item of prevViolationListCopy) { delete item._parseObject }
							for (let item of violationListCopy) { delete item._parseObject }

							prevState.reportedViolation = prevViolationListCopy;
							currentState.reportedViolation = violationListCopy;
						}

						if(Array.isArray(duesExtensions) && duesExtensions.length > 0) {
							extensions = extensions.concat(duesExtensions);

							let prevHoaDueListCopy = JSON.parse(JSON.stringify(prevHoaDueList));
							let hoaDueListCopy = JSON.parse(JSON.stringify(hoaDues));

							for (let item of prevHoaDueListCopy) { delete item._parseObject }
							for (let item of hoaDueListCopy) { delete item._parseObject }

							prevState.hoaDues = prevHoaDueListCopy;
							currentState.hoaDues = hoaDueListCopy;
						}

						await createLogs(props.view,result.data.objectId,prevState,currentState, '', extensions);
					}

					if(result.data.hoaId && result.data.hoaId != preHoaId) {
						let billableItem = "";
						if(result.data?.propertiesNumberOfHOA?.propertyNumberByOrg == 1) {
							billableItem = "First property addition";
						}
						else if(result.data?.propertiesNumberOfHOA?.propertyNumberByOrg > 1) {
							billableItem = "Subsequent Property addition";
						}
						await createLogs('propertyAssigned', result.data.hoaId, selectedValues, result.data, 'Hoa', [], billableItem, result.data.objectId);
					}
					updateSelectedValues(result.data);
					setFiles({
						propertyNoticeFiles:[],
						hearingNoticeFiles: []
					})
					props.setSuccess(true);
					setPrevHoaId(result.data.hoaId)
					await isMailVerifiedWithPropertyCheck()
					props.setView("view");
				}
			}
			setLoading(false);
		}
		catch(error){
			setShowApiErrorModal(true)
			setLoading(false)
		}
	 }
	}
	
	const backTOHOAsettingClick = () => {
		if(view === 'add') {
			setSelectionFromAdd(true)
		} else if (view === 'update'){
			setPrevHoaId(propertyData.hoaId);
			setSelectionFromAdd(false)
		}
		setSkipStatus(view);
		setView('selectHoa')
	}

	const getViolations = async () => {
		setViolationLoading(true)
		let { data: violations } = await dashboardServices.getPropetyViolations(selectedValues.objectId);
		
		if(Array.isArray(violations) && violations.length > 0) {
			for(let i=0; i<violations.length; i++) {
				violations[i].isDeleted = false;
			}
		}
		else{
			setIsViolationListEmpty(true)
		}
		
		setViolationLists(JSON.parse(JSON.stringify(violations)));
		setPrevViolationLists(JSON.parse(JSON.stringify(violations)));
		setViolationLoading(false)
	}

	const getHoaDues = async () => {
		setHoaDueLoading(true)
		let { data: hoaDues } = await dashboardServices.getHoaDues(selectedValues.objectId);
		
		if(Array.isArray(hoaDues) && hoaDues.length > 0) {
			for(let i=0; i<hoaDues.length; i++) {
				hoaDues[i].isDeleted = false;
			}
		}
		else{
			setIsHoaDueListEmpty(true)
		}
		
		setHoaDueLists(JSON.parse(JSON.stringify(hoaDues)));
		setPrevHoaDueList(JSON.parse(JSON.stringify(hoaDues)));
		setHoaDueLoading(false)
	}

	useEffect(() => {
		if(view === 'update') {
			if(isSelectionFromAdd){
				setPrevHoaId(selectedValues.hoaId);
				setPropertyData(selectedValues);
				if(violationList.length === 0 && !isViolationLoading && !IsViolationListEmpty) {
					getViolations()
				}
				if(hoaDueList.length === 0 && !isHoaDueLoading && !IsHoaDueListEmpty) {
					getHoaDues()
				}
			}
		} else if(view === 'selectHoa'){
			setPropertyData({
				...propertyData,
				hoaId: '',
				hoaPropertyDetails: {
					...propertyData['hoaPropertyDetails'],
					market: '',
				},
				info: {
					...propertyData['info'],
					city: '',
					state: '',
					zip: '',
					country: 'USA',
				}
			});
		} else if(view === 'view') {
			getViolations()
			getHoaDues()
		}

		return () => {
			setPropertyData((prev: any) => ({
				hoaId: prev.hoaId, 
				...Object.fromEntries(
				Object.entries(selectedValues).filter(([key]) => key !== 'hoaId') 
			)
		}));
};


	}, [view]);


	const onOverviewErrorCheck = () => {
		const error: any = {};
		let isEmpty = false;

		["externalId"]
			.map((title: string) => {
				if (!propertyData.hoaPropertyDetails[title] || propertyData.hoaPropertyDetails[title].length === 0) {
					error[title] = true;
					isEmpty = true;
				}
			});

		["street"]
			.map((title: string) => {
				const data: any = propertyData;
				if (!propertyData.info[title] || propertyData.info[title].length === 0) {
					error[title] = true;
					isEmpty = true;
				}
			});


		if (!propertyData['organizationName'] || propertyData['organizationName'].length === 0) {
			error['organizationName'] = true;
			isEmpty = true;
		}

		setError(error)
		return isEmpty;
	}

	const onChangeText = (event: any, type: string) => {
		let tempState = {...propertyData};
		let key = '';
		let value = '';
		if (type !== '') {
			if (event?.date) {
				key = event.date.key;
				value = event.date.value;
			}
			else if( event.target.type === 'checkbox'){
				key = event.target.name,
				value = event.target.checked
			}
			 else {
				key = event.target.name;
				value = event.target.value;
			}
			if(event.target?.name === 'underManagement'){
				if(event.target.value === 'yes'){
					tempState = {
						...tempState,
						[type]: {
							...tempState[type],
							['effectiveSoldDate']: '',
							['underManagementEffectiveSoldDateAdditionalInfo']: ''
						}
					}
					setPropertyData(tempState)
				}else{
					tempState = {
						...tempState,
						[type]: {
							...tempState[type],
							['underManagementAdditionalInfo']: ''
						}
					}
					setPropertyData(tempState)
				}
			}

			tempState = {
				...tempState,
				[type]: {
					...tempState[type],
					[key]: value
				}
			}

			setPropertyData(tempState)
			setError({
				...error,
				[key]: false,
			})
		} else {

			if (event?.date) {
				key = event.date.key;
				value = event.date.value;
			} else {
				key = event.target.name;
				value = event.target.value;
			}

			tempState = {
				...tempState,
				[key]: value
			}
			setPropertyData(tempState)
			setError({
				...error,
				[key]: false,
			})
		}
	}

	const onDeleteClick = async () => {
        setLoading(true);
        const value = await dashboardServices.removeProperty(selectedValues.objectId,selectedValues.hoaId, selectedValues.organizationId);

		if(value.data && value.data.id){
			updateLocalHoaInfo(value.data.id,value.data.number);
		}

        if(value && value.data){
            await createLogs('remove',selectedValues.objectId);
			if(selectedValues.hoaId) {
				await createLogs('deleteProperty', selectedValues.hoaId, {}, {}, 'Hoa');
			}
            const updatedData = property.data.filter(((value:any) => value.objectId !== selectedValues.objectId))
            updatePropertyData({
                ...property,
                data: updatedData,
            });
            setSuccess(true);
			changeActiveMenu(activeMenu,false, "", -1);
            updateView('remove-from-list')
            setLoading(false);
        }
	}

	useEffect(() => {
		if (view === 'update' && !isPropertyOverviewUpdate(selectedValues, propertyData) || files.propertyNoticeFiles.length > 0) {
			setIsDisabled(false);
		}
		if (view === 'update' && !isPropertyViolationBasicInfoUpdate(selectedValues, propertyData)) {
			setIsDisabled(false);
		}
		if(view === 'update' && getCreatedOrUpdatedViolations(prevViolationList, violationList, false).length != 0) {
			setIsDisabled(false);
		}
		if(view === 'update' && getCreatedOrUpdatedHoaDues(prevHoaDueList, hoaDueList, false).length != 0) {
			setIsDisabled(false);
		}
	},[selectedValues, propertyData, files, violationList, hoaDueList])

	return (
		<>
			<LoadingComponent loading={loading} />
			<DeleteContainerModal type={"Property"} onDeleteClick={onDeleteClick} isDeleteModal={isDeleteModal} setIsDeleteModal={setIsDeleteModal} />
			<BillableItemsModal 
			    billItems={datastore.billableItemsOptions.property}
                selectedBillItem={selectedBillItem}
                setSelectedBillItem={setSelectedBillItem}
                evidenceLink={evidenceLink}
                setEvidenceLink={setEvidenceLink}
                onSaveClick={onSaveClick}
                isBillableItemsModal={isBillableItemsModal}
                setIsBillableItemsModal={setIsBillableItemsModal} 
                tagType={'Property'} 
                setLoading={setLoading}
                view={view}
				sourceId={sourceId}
				setSourceId={setSourceId}
				isVerified={isVerified}
				setIsVerified={setIsVerified}
				sourceDocumentType={sourceDocumentType}
    			setSourceDocumentType={setSourceDocumentType}
				linkedEntryId={linkedEntryId}
                setLinkedEntryId={setLinkedEntryId}
				documentId={documentId}
				setDocumentId={setDocumentId}
				isDocumentIdVerified={isDocumentIdVerified}
				setIsDocumentIdVerified={setIsDocumentIdVerified}
            />
			<SubHeaderComponent
				view={view}
				warning={false}
				loading={loading}
				selectedValues={selectedValues}
				tagType={"Property"}
				selectedTabTitle={config.propertyTabTitles[activeTab]}
				onSaveClick={onSaveClick}
				onDeleteClick={()=>setIsDeleteModal(true)}
				onCancelClick={onCancelClick}
				onUpdateClick={onUpdateClick}
				editOptionEnabledFromView={!["Change Log" , "Mails", "Emails"].includes(config.propertyTabTitles[activeTab])}
				setIsBillableItemsModal={setIsBillableItemsModal}
				isDisabled={isDisabled}
				onCancelYesClick={onCancelYesClick}
			/>
			<TryagainModal
                open={showApiErrorModal}
                errorMessage="Save failed. Please try again."
                onClose={()=>setShowApiErrorModal(false)}
                onTryAgain={onSaveClick}
            />

			<EditCancelConfirmationModal 
				isCancelClicked={isCancelClicked}
				setIsCancelClicked={setIsCancelClicked}
				onCancelYesClick={onCancelYesClick}
			/>

			{(view === "add" || view === "update") && (
				<div className="property-back-to-hoa-container">
					<Button
						onClick={() => backTOHOAsettingClick()}
						style={{ marginLeft: "8px" }}
						color="primary"
						startIcon={<ArrowBackIcon />}
					>
						<span className="text-3576E5-14px">Back To HOA settings</span>
					</Button>
				</div>
			)}

			{view === "selectHoa" && (
				<HoaSelectingComponent
					setView={setView}
					setPropertyData={setPropertyData}
					propertyData={propertyData}
					isSelectionFromAdd={isSelectionFromAdd}
					skipPrevStatus={skipPrevStatus}
					setIsDisabled={setIsDisabled}
				/>
			)}

			{view === "add" && (
				<div
					style={{
						height: window.innerHeight - datastore.responsiveHeight - 56,
						overflowY: "auto",
					}}
				>
					<PropertyBasicDetailsForm
						propertyData={propertyData}
						setPropertyData={setPropertyData}
						onChangeText={onChangeText}
						setError={setError}
						error={error}
						view={view}
						files={files}
						setFiles={setFiles}
					/>
				</div>
			)}

			{view !== "add" && view !== "selectHoa" && (
				<>
					<div style={{ borderBottom: "1px solid #E8E8E8" }}>
						<Tabs
							value={activeTab}
							onChange={(event, value) => {
								updateActiveTab(value);
							}}
						>
							{config.propertyTabTitles
								.map((title: string, index: number) => {
									if (view === "update" && (title === "Change Log" || title === "Mails" || title === "Emails")) return;
									else if (view === "update" && title === "Documents") return;

									return (
										<Tab
											key={index}
											label={title}
											value={index}
											style={{ minWidth: "143px", textTransform: "none" }}
										/>
									);
								})
								.filter((value:any) => value !== undefined)}
						</Tabs>
						<div
							style={{
								height:
									view === "update"
										? window.innerHeight -
										  datastore.responsiveHeightWithtab -
										  56
										: window.innerHeight - datastore.responsiveHeightWithtab,
								overflowY: "auto",
							}}
						>
							{view === "update" &&
							(
								<>
									{activeTab === 0 ? (
										<PropertyBasicDetailsForm
											propertyData={propertyData}
											setPropertyData={setPropertyData}
											onChangeText={onChangeText}
											setError={setError}
											error={error}
											view={view}
											files={files}
											setFiles={setFiles}
										/>
									) : (
										<PropertyViolationDetails
											view={props.view}
											propertyData={propertyData}
											setPropertyData={setPropertyData}
											onChangeText={onChangeText}
											hoaDueList={hoaDueList}
											setHoaDueLists={setHoaDueLists}
											isHoaDueLoading={isHoaDueLoading}
											setHoaDueLoading={setHoaDueLoading}
											violationList={violationList}
											setViolationLists={setViolationLists}
											isViolationLoading={isViolationLoading}
											setViolationLoading={setViolationLoading}
											violationError={violationError}
											setViolationError={setViolationError}
											files={files}
											setFiles={setFiles}
											parentViolationList={parentViolationList}
											reorderedViolations={reorderedViolations}
											setReorderedViolations={setReorderedViolations}
										/>
									)}
								</>
							)
							}
							{view === "view" &&
								<PropertyViewContainer setHoaDueLists={setHoaDueLists} isHoaDueLoading={isHoaDueLoading} hoaDueList={hoaDueList} setViolationLists={setViolationLists} isViolationLoading={isViolationLoading} violationList={violationList} tabIndex={activeTab} />
							}
						</div>
					</div>
				</>
			)}
		</>
	);
}


export default PropertyCrudComponent;

const HoaSelectingComponent = ({ setView, setPropertyData, propertyData, isSelectionFromAdd, skipPrevStatus, setIsDisabled }: any) => {

	const [hoaId, setHoaId] = useState('')
	const [hoaName, setHoaName] = useState('')
	const [details, setDetails]: any = useState({})
	const [isLoading, setLoading]: any = useState(false)
	const [hoaList, setHoaList] = useState([])

	const onSearchClick = async () => {
		setLoading(true)
		
		if (hoaId) {
			const excludeDeletedHoa = true;
			const response = await dashboardServices.getHoaById(hoaId, datastore.selectedOrganization?.id, excludeDeletedHoa);

			if(response.data == "Object Not found"){
				window.alert('Please provide correct HOA id')
				setLoading(false)
				return;
			}
			setHoaList([response?.data])
			handleSetHoa(response?.data)

		} else if (hoaName) {
			const response = await dashboardServices.getHoasByName(hoaName);
			if(response.data == "Object Not found"){
				window.alert('Please provide correct HOA name')
				setLoading(false)
				return;
			} else if(response?.data.length === 1) {
				setHoaList(response.data)
				handleSetHoa(response.data[0])
			} else {
				setHoaList(response.data)
			}
		}
		setLoading(false)
	}

	const handleSetHoa = (hoa: any) => {
		setDetails({
			objectId: hoa.objectId,
			name: hoa.name,
			address: hoa.address,
			city: hoa?.municipality.city,
			state: hoa?.municipality.state,
			market: hoa?.municipality.market,
			masterHoa: hoa?.masterHoa
		})
		setIsDisabled(false);
		setLoading(false)
		setPropertyData({
			...propertyData,
			hoaId: hoa.objectId,
			hoaPropertyDetails: {
				...propertyData['hoaPropertyDetails'],
				market: hoa?.municipality.market,
			},
			info: {
				...propertyData['info'],
				city: hoa?.municipality.city,
				state: hoa?.municipality.state,
				zip: hoa?.zip,
			}
		})
	}

	const onNextClick = () => {
		if(isSelectionFromAdd) {
			setView('add')
		} else {
			setView('update')
		}
	}

	const onSkipClick = () => {
		if(skipPrevStatus === 'add'){
			setView('add');
		} else {
			setView('update');
		}
	}

	const renderHoaType = (hoa:any) => {
		if(hoa && hoa.name) {
			const {
				masterHoa
			} = hoa;
	
			let backgroundColor = '';
			let type = '';
	
			if (masterHoa) {
				backgroundColor = "#EDE7F6";
				type = 'Sub-HOA';
			}
			else {
				backgroundColor = '#FFECB3';
				type = 'Master HOA'
			}
	
			
			return (
				<div className="text-787878-14px bold" style={{ background: backgroundColor, padding: "5px 15px 5px 15px", textAlign: "center", borderRadius: 4, fontWeight: 500, minWidth: 60, width: 80 }}>
					{type}
				</div>
			);	
		}
		else {
			return <></>;
		}
    }

	const handleSetHoaField = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, field: string) => {
		if (field === 'id') {
			setHoaId(e.target.value);
			setHoaName('');
		} else if (field === 'name') {
			setHoaName(e.target.value);
			setHoaId('');
		}
	};

	return (
		<Stack padding={"24px"} spacing={2} direction={"column"}>
			<span style={{ marginBottom: "10px" }} className="text-3E3E3E-18px">
				HOA Settings
			</span>
			<Stack alignItems={"center"} direction={"row"} spacing={2}>
				<TextField
					style={{ padding: "10px 0px", width: "241px" }}
					label="HOA ID"
					placeholder="Search by HOA ID"
					variant="standard"
					value={hoaId}
					onChange={(e) => handleSetHoaField(e, 'id')}
				/>
				<TextField
					style={{ padding: "10px 0px", width: "241px" }}
					label="HOA Name"
					placeholder="Search by HOA Name"
					variant="standard"
					value={hoaName}
					onChange={(e) => handleSetHoaField(e, 'name')}
				/>
				<Button
					onClick={() => onSearchClick()}
					variant="contained"
					color="primary"
					style={{ width: "109px", height: "40px" }}
				>
					<span style={{ textTransform: "capitalize" }}>Search</span>
				</Button>
			</Stack>
			<div>
				{isLoading && <LinearProgress style={{ height: "2px" }} />}
				<TableContainer component={'div'}>
					<Table sx={{ minWidth: 650 }} aria-label="simple table">
						<TableHead>
							<TableRow
								sx={{
									"& th": {
										color: "#3E3E3E",
										backgroundColor: "#F7F7F7",
									},
								}}
							>
								<TableCell>Name</TableCell>
								<TableCell align="center">HOA Address</TableCell>
								<TableCell align="center">Market</TableCell>
								<TableCell align="center">State</TableCell>
								<TableCell align="center">City</TableCell>
								<TableCell align="center">Type</TableCell>
								<TableCell style={{backgroundColor:"#F7F7F7", width:"30px"}}> </TableCell>
							</TableRow>
						</TableHead>
						{
							!isLoading &&
							<TableBody>
								{hoaList.map((item) => (
								<TableRow key={item.id} onClick={() => handleSetHoa(item)} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
									<TableCell component="th" scope="row">
										{item.name}
									</TableCell>
									<TableCell align="center">{item.address}</TableCell>
									<TableCell align="center">{item.market}</TableCell>
									<TableCell align="center">{item.state}</TableCell>
									<TableCell align="center">{item.city}</TableCell>
									<TableCell style={{ display: 'flex', justifyContent: 'center' }} align="center">{renderHoaType(item)}</TableCell>
									<TableCell align="left">{item && item?.objectId === details?.objectId ? <CheckCircle color="primary"/> : ''}</TableCell>
								</TableRow>
								))}

							</TableBody>
						}
					</Table>
				</TableContainer>
			</div>
			<Stack direction={'row'} alignSelf={'flex-end'} spacing={1}>
				<Button
					onClick={() => onSkipClick()}
					disabled={Object.keys(details).length > 0}
					color="primary"
					style={{ width: "109px", height: "40px" }}
				>
					<span style={{ textTransform: "capitalize" }}>Skip</span>
				</Button>
				<Button
					disabled={Object.keys(details).length === 0}
					onClick={() => {onNextClick()}}
					variant="contained"
					color="primary"
					style={{ width: "109px", height: "40px" }}
				>
					<span style={{ textTransform: "capitalize" }}>Next</span>
				</Button>
			</Stack>
		</Stack>
	);
}